import React, { Component } from 'react';
import classnames from 'classnames';
import { LoadingIndicator } from 'common/components/preloader';
import { subscribeRequest } from 'marketing/ducks';

export default class DripCampaignSubscription extends Component {
  constructor(props) {
    super(props);

    this.state = { subscribing: true, error: false };
  }

  componentDidMount() {
    const { location: { query } } = this.props;

    subscribeRequest({ email: query.email, intercom_tag: query.intercom_tag }).then(() => {
      this.setState({ subscribing: false });
    }).catch(() => {
      this.setState({ subscribing: false, error: "Error subscribing to campaign. Please try again." });
    });
  }

  render() {
    const { subscribing, error } = this.state;
    const { location: { query } } = this.props;

    return (
      <div className="l-content drip-campaign-subscription" id="content">
        { subscribing?
        <LoadingIndicator /> :
        <div className="row">
          <div className="columns medium-9 small-16">
            <h4>
              { error?
              error :
              <span>We just sent the first lesson to { query.email }.<br/> Grab it from your inbox.</span> }
            </h4>
          </div>
          <div className="columns medium-7 small-16 icon hide-for-small-only">
            <img src="https://s3.amazonaws.com/crowdspring3-assets/marketing/grabby-for-drip.png" />
          </div>
        </div> }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./landing_pages/components/drip_campaign_subscription.jsx